export const RESOURCE_TYPE_PROJECTS_COMPONENTS = 'PROJECTS_COMPONENTS';
